import type { TeamRole } from '@indutrust/shared-model';

/** PrimeNG tag severity for a {@link TeamRole} badge. */
export function getTeamRoleSeverity(
  role: TeamRole
): 'info' | 'secondary' | 'success' {
  switch (role) {
    case 'owner':
      return 'success';
    case 'manager':
      return 'info';
    case 'viewer':
      return 'secondary';
  }
}
